import moment from "moment";
import { Service } from "./Service";
import { DataBase } from "./DataBase";
import { Allocation } from "./Allocation";

export class Adapter {
  static blank() {
    return new this({});
  }

  constructor(json) {
    Object.assign(this, json);
  }

  static fromServer(json) {
    return new Adapter({
      projectId: json.id || "",
      name: json.project || "",
      service: new Service({
        os: json.os,
        cpu: json.cpu,
        memory: json.rom,
        hardDisk: json.ram,
        serviceIp: json.engineIp,
        // servicePwd: json.enginePwd && window.atob(json.enginePwd),
        network: json.web,
      }),
      dataBase: new DataBase({
        port: json.port,
        version: 'DM 8.1',
        frameWork: json.dbaFrame,
        userName: json.dbaName,
        // dataBasePwd: json.dbaPwd && window.atob(json.dbaPwd),
      }),
      status: json.status,
      statusName:
        json.status === "0" || json.status === "1"
          ? "待审核"
          : json.status === "2"
            ? "适配中"
            : json.status === "3"
              ? "已完成"
              : json.status === "4"
                ? "已结束"
                : json.status === "7"
                  ? "已暂停"
                  : "未通过",
      statusColor: json.status === "0" || json.status === "1"
        ? "#4771F8"
        : json.status === "2"
          ? "#F89F47"
          : json.status === "3"
            ? "#2FAA76"
            : json.status === "4"
              ? "#222222"
              : "#FA543C",
      type: json.type,
      reason: json.reason || "",
      sumDays: json.allDay,
      useDays: json.useDay,
      adapterApply: json.userName && new AdapterApply({
        type: json.type,
        phone: json.telephone,
        name: json.project || "",
        company: json.company,
        email: json.email,
        applier: json.userName,
      }),
      allocate: json.distributionServers && json.distributionServers.map(v => {
        return new Allocation({
          projectId: json.id,
          cloudId: v.dataId,
          cloudIp: v.ip,
          account: 'root',
          password: decodeURIComponent(escape(atob(v.password))),
          dbaVersion: 'DM 8.1',
          port: v.dbPort,
          saAccount: v.dbUser,
          saPwd: decodeURIComponent(escape(atob(v.dbPassword))),
        })
      }),
      reason: json.reason,
      startTime: moment(json.createTime).format("YYYY-MM-DD HH:mm:ss"),
      rate: json.starRating && json.starRating ? json.starRating : 5,
      rateContent: json.starSuggest,
      isEvaluate: json.isEvaluate
    });
  }

  projectId = "";
  name = "";
  service = Service.blank();
  dataBase = DataBase.blank();
  adapterApply = AdapterApply.blank();
  allocate = Allocation.blank();
  status = "";
  statusName = "";
  type = "";
  reason = "";
  sumDays = 50;
  useDays = 0;
  startTime = moment();
  endTime = moment();
  rate = 5;
  rateContent = "";
}

export class AdapterApply {
  company = "";
  name = "";
  phone = "";
  email = "";
  applier = "";
  type = "dm8"; // 套餐类型  dm8 dm8+linux dm8+windows
  static blank() {
    return new this({});
  }

  static fromServer(json) {
    return new AdapterApply({
      type: json.type,
      phone: json.telephone,
      name: json.project || "",
      applier: json.userName,
      company: json.company,
      email: json.email,
    })
  }

  toServer() {
    return {
      type: this.type,
      telephone: this.phone,
      project: this.project,
      userName: this.applier,
      company: this.company,
      email: this.email,
    };
  }

  constructor(json) {
    Object.assign(this, json);
  }
}
